<template>
    <div class="nature-page">
        <!-- 1. 顶部标题栏 -->
        <div class="nature-top-bar">
            <div class="title-bar nature-title-bar dsp-flex">
                <div class="title-side title-side-left" @click="clickBack">
                    <span class="title-back-icon"><i class="iconfont icon-xiangzuo"></i></span>
                </div>
                <div class="title-middle">天赋性格智能解析</div>
                <div v-if="(natureCharacterData.needpay == 1 || natureTalentData.needpay == 1) && natureTimeLimit != 0" class="title-side title-side-right">
                    <div class="nature-time" :style="showCount ? 'opacity: 1' : 'opacity: 0'">{{countTimeStr}}</div>
                </div>
            </div>
        </div>

        <!-- 2. 主要内容部分 -->
        <div class="nature-main-content">
            <!-- 性格部分 -->
            <nature-character v-if="natureTalentData.needpay == 0 || (natureCharacterData.needpay == 1 && natureTalentData.needpay == 1)"></nature-character>
            <!-- 天赋部分 -->
            <nature-talent :resultType="'talent'"></nature-talent>
            <!-- 性格部分 -->
            <nature-character v-if="natureTalentData.needpay == 1 && natureCharacterData.needpay == 0"></nature-character>
            <!-- 按钮部分 -->
            <div class="nature-sub-btn" @click="clickReport">
                <span>查看一生运程测评</span>
            </div>

            <div v-if="natureCharacterData.needpay == 1 && natureTalentData.needpay == 1" class="nature-main-button">
                <nature-button
                    v-bind:buttonType="'1'"
                    v-bind:productData="natureGiftData"
                    v-bind:discount="natureTimeLimit != 0"
                    v-bind:showLimit="natureTimeLimit != 0"
                    v-bind:showTwo="natureTimeLimit != 0"
                    v-bind:clickFunc="clickPay">
                </nature-button>
                <p v-if="natureTimeLimit != 0" class="nature-main-button-note">{{countTimeStr}}后恢复原价{{natureGiftData.rate_price ? parseFloat(natureGiftData.rate_price/100) : ''}}元</p>
            </div>
        </div>

        <!-- 3. vip解锁按钮 -->
        <!-- <vip-button v-if="showVipBtn" :frompage="'nature'"></vip-button> -->
        <router-view></router-view>
    </div>
</template>

<script>
import VipButton from '../../components/common/VipButton.vue'
import NatureButton from '../../layouts/nature/NatureButton.vue'
import NatureCharacter from '../../layouts/nature/NatureCharacter.vue'
import NatureTalent from '../../layouts/nature/NatureTalent.vue'
import { CONFIG } from '../../modules/config'
import { MIX, UTILS } from '../../modules/utils'
export default {
    name: 'Nature',
    components: { VipButton, NatureButton, NatureCharacter, NatureTalent },
    computed: {
        natureGiftData() {
            return this.$store.state.report.natureGiftData;
        },
        natureCharacterData() {
            return this.$store.state.report.natureCharacterData;
        },
        natureTalentData() {
            return this.$store.state.report.natureTalentData;
        },
        natureTimeLimit() {
            return this.$store.state.report.natureTimeLimit;
        },
        showVipBtn() {
            return this.$store.state.report.showVipBtn;
        }
    },
    data() {
        return {
            showCount: false,
            countTimeStr: '',
            countFunc: undefined,
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initData();
            me.initTimeCountDown();
            MIX.trackPageViewed('TalentPage', 'mingpan_talent');
        }, 20);
        setTimeout(() => {
            me.showCount = true;
        }, 1000);
    },
    methods: {
        initData() {
            var detailInfo = this.$store.state.detail.personInfo;
            if(!detailInfo.id) {
                this.$router.replace('/record')
            }
        },
        initTimeCountDown() {
            var me = this,
                curSecond = this.natureTimeLimit;
            console.log('initTimeCountDown------', curSecond)
            this.countTimeStr = UTILS.getTimeStrBySecond(curSecond);
            this.countFunc = setTimeout(count, 1000)
            function count() {
                curSecond--;
                clearTimeout(me.countFunc);
                if(curSecond >= 0) {
                    me.$store.state.report.natureTimeLimit = curSecond;
                    me.countTimeStr = UTILS.getTimeStrBySecond(curSecond);
                    me.countFunc = setTimeout(count, 1000);
                }
            }
        },
        clickBack() {
            let showReportPage = this.$store.state.report.showReportPage;
            console.log('Nature----clickBack----', showReportPage);
            var curPath = this.$router.history.current.fullPath;
                curPath = showReportPage ? curPath.replace('/nature', '/report') : curPath.replace('/nature', '/detail');
            if(curPath.indexOf('/report') == -1) {
                this.$store.dispatch('report/resetNatureData');
            }
            this.$router.replace(curPath);
            clearTimeout(this.countFunc);
        },
        clickReport() {
            var me = this,
                curPath = this.$router.history.current.path,
                detailInfo = this.$store.state.detail.personInfo;
            curPath = curPath.replace('/nature', '/report');
            this.$store.state.report.fromPage = 'nature';
            this.$store.dispatch('report/initReportAIConfig');
            this.$store.dispatch('report/getReportInfo', {
                detailInfo: detailInfo,
                cb: function() {
                    // 更新状态
                    var params = {"aitips": 1};
                    me.$store.dispatch('reminder/udpateExtList', {
                        params: params
                    });
                    me.$router.replace(curPath);
                }
            });
        },
        clickPay(params) {
            var me = this,
                curSecond = this.$store.state.report.natureTimeLimit,
                detailInfo = this.$store.state.detail.personInfo;
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: params.data.pid,              //支付项目id
                    ptype: params.data.payType[2],     //支付方式
                    ext: detailInfo.id,                //支付的评测id
                    discount: curSecond > 0 ? CONFIG.character_discount : 1  //支付折扣
                },
                mixParams: {
                    pid: params.data.pid,
                    product_name: params.data.title,
                    price: params.data.price,
                    from: 'nature',
                },
                sucCb: function() {
                    console.log('支付成功，更新测评报告数据');
                    // 更新测验报告数据
                    if(detailInfo) {
                        me.$store.dispatch('report/getAiCharacter', {
                            detailInfo: detailInfo
                        });
                    }
                    // 更新ai状态
                    // me.$store.state.detail.personInfo.ai = 1;
                    // me.$store.dispatch('record/updateRecordListAIStatus', {
                    //     id: detailInfo.id
                    // });
                    
                    // 清除定时器
                    clearTimeout(me.countFunc);

                    // 支付成功
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: function() {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });
        }
    }
}
</script>